import { gql } from '@apollo/client';
import { ScheduledShipmentInfoShared } from '../fragments';

export default gql`
  query scheduledShipments(
    $accountId: ID
    $patientId: ID
    $consumed: Boolean
    $expectedShippedAtStart: String
    $expectedShippedAtEnd: String
    $limit: Int
    $offset: Int
  ) {
    scheduledShipments(
      accountId: $accountId
      patientId: $patientId
      consumed: $consumed
      expectedShippedAtStart: $expectedShippedAtStart
      expectedShippedAtEnd: $expectedShippedAtEnd
      limit: $limit
      offset: $offset
    ) {
      ...ScheduledShipmentInfoShared
    }
  }
  ${ScheduledShipmentInfoShared}
`;
